import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser, fetchLandingPageListings } from '../../ducks/user.duck';
import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { PROFILE_PAGE_PENDING_APPROVAL_VARIANT } from '../../util/urlHelpers';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { hasPermissionToViewData, isUserAuthorized } from '../../util/userHelpers';
// import { fetchCombineSpaceTopics } from '../CircleCommunityPage/CircleCommunityPage.duck';
import { searchGroups } from '../GroupSearchPage/GroupSearchPage.duck';
import {
  fetchPublicProfileCircleDataApi,
  fetchUserActivityApi,
  fetchUserBadgesApi,
  getPublicProfileUserSummaryApi,
} from '../../util/api';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/ProfilePage/SET_INITIAL_STATE';

export const SHOW_USER_REQUEST = 'app/ProfilePage/SHOW_USER_REQUEST';
export const SHOW_USER_SUCCESS = 'app/ProfilePage/SHOW_USER_SUCCESS';
export const SHOW_USER_ERROR = 'app/ProfilePage/SHOW_USER_ERROR';

export const QUERY_LISTINGS_REQUEST = 'app/ProfilePage/QUERY_LISTINGS_REQUEST';
export const QUERY_LISTINGS_SUCCESS = 'app/ProfilePage/QUERY_LISTINGS_SUCCESS';
export const QUERY_LISTINGS_ERROR = 'app/ProfilePage/QUERY_LISTINGS_ERROR';

export const QUERY_REVIEWS_REQUEST = 'app/ProfilePage/QUERY_REVIEWS_REQUEST';
export const QUERY_REVIEWS_SUCCESS = 'app/ProfilePage/QUERY_REVIEWS_SUCCESS';
export const QUERY_REVIEWS_ERROR = 'app/ProfilePage/QUERY_REVIEWS_ERROR';

// Store first transaction summary involving current user and the viewed user
export const SET_MESSAGE_TX_SUMMARY = 'app/ProfilePage/SET_MESSAGE_TX_SUMMARY';
// Flag for whether profile has been approved (controls badge visibility)
export const SET_PROFILE_APPROVAL = 'app/ProfilePage/SET_PROFILE_APPROVAL';
// Flag for whether Stripe account is linked (both link status and accountId present)
export const SET_STRIPE_LINKED = 'app/ProfilePage/SET_STRIPE_LINKED';


export const REQUEST_SPACE_LIST = 'app/ProfilePage/REQUEST_SPACE_LIST';
export const SUCCESS_SPACE_LIST = 'app/ProfilePage/SUCCESS_SPACE_LIST';
export const ERROR_SPACE_LIST = 'app/ProfilePage/ERROR_SPACE_LIST';

export const FETCH_USER_ACTIVITY_REQUEST = 'app/ProfilePage/FETCH_USER_ACTIVITY_REQUEST';
export const FETCH_USER_ACTIVITY_SUCCESS = 'app/ProfilePage/FETCH_USER_ACTIVITY_SUCCESS';
export const FETCH_USER_ACTIVITY_ERROR = 'app/ProfilePage/FETCH_USER_ACTIVITY_ERROR';

export const FETCH_USER_EMAIL = 'app/ProfilePage/FETCH_USER_EMAIL';

export const FETCH_USER_BADGES_REQUEST = 'app/ProfilePage/FETCH_USER_BADGES_REQUEST';
export const FETCH_USER_BADGES_SUCCESS = 'app/ProfilePage/FETCH_USER_BADGES_SUCCESS';
export const FETCH_USER_BADGES_ERROR = 'app/ProfilePage/FETCH_USER_BADGES_ERROR';

export const SET_SUBSCRIPTION_DATA = 'app/ProfilePage/SET_SUBSCRIPTION_DATA';

// ================ Reducer ================ //

const initialState = {
  userId: null,
  userListingRefs: [],
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
  messageTxSummary: null,
  profileApproved: false,
  stripeLinked: false,

  requestSpaceList: false,
  spaceListData: [],
  errorSpaceList: null,

  fetchUserActivityRequest: false,
  fetchUserActivityData: null,
  fetchUserActivityError: null,
  userEmail: null,

  fetchUserBadgesRequest: false,
  userBadges: [],
  fetchUserBadgesError: null,

  subscriptionData: null,
};

export default function profilePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case FETCH_USER_ACTIVITY_REQUEST:
      return {
        ...state,
        fetchUserActivityRequest: true,
        fetchUserActivityData: null,
        fetchUserActivityError: null
      };
    case FETCH_USER_ACTIVITY_SUCCESS:
      return {
        ...state,
        fetchUserActivityRequest: false,
        fetchUserActivityData: payload,
        fetchUserActivityError: null
      };
    case FETCH_USER_ACTIVITY_ERROR:
      return {
        ...state,
        fetchUserActivityRequest: false,
        fetchUserActivityData: null,
        fetchUserActivityError: true
      };

    case REQUEST_SPACE_LIST:
      return { ...state, requestSpaceList: true };
    case SUCCESS_SPACE_LIST:
      return { ...state, requestSpaceList: false, spaceListData: payload.data };
    case ERROR_SPACE_LIST:
      return {
        ...state,
        requestSpaceList: false,
        errorSpaceList: payload.error,
      };

    case SET_INITIAL_STATE:
      return { ...initialState };
    case SHOW_USER_REQUEST:
      return { ...state, userShowError: null, userId: payload.userId };
    case SHOW_USER_SUCCESS:
      return state;
    case SHOW_USER_ERROR:
      return { ...state, userShowError: payload };

    case QUERY_LISTINGS_REQUEST:
      return {
        ...state,

        // Empty listings only when user id changes
        userListingRefs: payload.userId === state.userId ? state.userListingRefs : [],

        queryListingsError: null,
      };
    case QUERY_LISTINGS_SUCCESS:
      return { ...state, userListingRefs: payload.listingRefs };
    case QUERY_LISTINGS_ERROR:
      return { ...state, userListingRefs: [], queryListingsError: payload };
    case QUERY_REVIEWS_REQUEST:
      return { ...state, queryReviewsError: null };
    case QUERY_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case QUERY_REVIEWS_ERROR:
      return { ...state, reviews: [], queryReviewsError: payload };

    case SET_MESSAGE_TX_SUMMARY:
      return { ...state, messageTxSummary: payload };

    case SET_PROFILE_APPROVAL:
      return { ...state, profileApproved: payload === true };

    case SET_STRIPE_LINKED:
      return { ...state, stripeLinked: payload === true };

    case FETCH_USER_EMAIL:
      return { ...state, userEmail: payload };

    case FETCH_USER_BADGES_REQUEST:
      return {
        ...state,
        fetchUserBadgesRequest: true,
        userBadges: [],
        fetchUserBadgesError: null,
      };
    case FETCH_USER_BADGES_SUCCESS:
      return {
        ...state,
        fetchUserBadgesRequest: false,
        userBadges: payload,
        fetchUserBadgesError: null,
      };
    case FETCH_USER_BADGES_ERROR:
      return {
        ...state,
        fetchUserBadgesRequest: false,
        userBadges: [],
        fetchUserBadgesError: payload,
      };

    case SET_SUBSCRIPTION_DATA:
      return {
        ...state,
        subscriptionData: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const showUserRequest = userId => ({
  type: SHOW_USER_REQUEST,
  payload: { userId },
});

export const showUserSuccess = () => ({
  type: SHOW_USER_SUCCESS,
});

export const showUserError = e => ({
  type: SHOW_USER_ERROR,
  error: true,
  payload: e,
});

export const queryListingsRequest = userId => ({
  type: QUERY_LISTINGS_REQUEST,
  payload: { userId },
});

export const queryListingsSuccess = listingRefs => ({
  type: QUERY_LISTINGS_SUCCESS,
  payload: { listingRefs },
});

export const queryListingsError = e => ({
  type: QUERY_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const queryReviewsRequest = () => ({
  type: QUERY_REVIEWS_REQUEST,
});

export const queryReviewsSuccess = reviews => ({
  type: QUERY_REVIEWS_SUCCESS,
  payload: reviews,
});

export const queryReviewsError = e => ({
  type: QUERY_REVIEWS_ERROR,
  error: true,
  payload: e,
});

export const setMessageTxSummary = summary => ({
  type: SET_MESSAGE_TX_SUMMARY,
  payload: summary,
});

export const setProfileApproval = approved => ({
  type: SET_PROFILE_APPROVAL,
  payload: approved,
});

export const setStripeLinked = linked => ({
  type: SET_STRIPE_LINKED,
  payload: linked,
});

export const requestSpaceList = () => ({
  type: REQUEST_SPACE_LIST,
});
export const successSpaceList = data => ({
  type: SUCCESS_SPACE_LIST,
  payload: { data },
});
export const errorSpaceList = error => ({
  type: ERROR_SPACE_LIST,
  payload: { error },
});

export const fetchUserActivityRequest = () => ({
  type: FETCH_USER_ACTIVITY_REQUEST
})

export const fetchUserActivitySuccess = (data) => ({
  type: FETCH_USER_ACTIVITY_SUCCESS,
  payload: data
})

export const fetchUserActivityError = (error) => ({
  type: FETCH_USER_ACTIVITY_ERROR,
  payload: error
})

export const fetchUserEmail = (email) => ({
  type: FETCH_USER_EMAIL,
  payload: email
})

export const fetchUserBadgesRequest = () => ({
  type: FETCH_USER_BADGES_REQUEST,
});

export const fetchUserBadgesSuccess = (badges) => ({
  type: FETCH_USER_BADGES_SUCCESS,
  payload: badges,
});

export const fetchUserBadgesError = (error) => ({
  type: FETCH_USER_BADGES_ERROR,
  payload: error,
});

export const setSubscriptionData = (data) => ({
  type: SET_SUBSCRIPTION_DATA,
  payload: data,
});

// ================ Thunks ================ //

export const queryUserListings = (userId, config, ownProfileOnly = false) => (
  dispatch,
  getState,
  sdk
) => {
  if(!userId){
    return Promise.resolve([]);
  }
  dispatch(queryListingsRequest(userId));

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const queryParams = {
    include: ['author', 'images'],
    'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  };

  const listingsPromise = ownProfileOnly
    ? sdk.ownListings.query({
      states: ['published'],
      ...queryParams,
    })
    : sdk.listings.query({
      author_id: userId,
      ...queryParams,
    });

  return listingsPromise
    .then(response => {
      // Pick only the id and type properties from the response listings
      const listings = response.data.data;
      const listingRefs = listings
        .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
        .map(({ id, type }) => ({ id, type }));
      dispatch(addMarketplaceEntities(response));
      dispatch(queryListingsSuccess(listingRefs));
      return response;
    })
    .catch(e => dispatch(queryListingsError(storableError(e))));
};

export const queryUserReviews = (userId) => (dispatch, getState, sdk) => {
  return sdk.reviews
    .query({
      subject_id: userId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(queryReviewsSuccess(reviews));
    })
    .catch(e => dispatch(queryReviewsError(e)));
};

export const getUserData = (userId) => (dispatch, getState, sdk) => {
  return getPublicProfileUserSummaryApi({ userId })
    .then(res => {
      const { profileApproved, subscriptionData, stripeLinked } = res || {};
      // Store subscription data in state
      if (subscriptionData) {
        dispatch(setSubscriptionData(subscriptionData));
      }

      dispatch(setProfileApproval(profileApproved === true));
      dispatch(setStripeLinked(stripeLinked === true));

      return res;
    })
    .catch(error => {
      // On error, default to not approved
      console.error('Error fetching user data:', error);
      dispatch(setProfileApproval(false));
      dispatch(setStripeLinked(false));
      dispatch(setSubscriptionData(null));
      return {};
    });
};

export const fetchUserActivity = (params) => async (dispatch, getState) => {
  try {
    dispatch(fetchUserActivityRequest())
    const response = await fetchUserActivityApi({ accessToken: params?.access_token, ...params });
    dispatch(fetchUserActivitySuccess(response))
  } catch (e) {
    console.log(e, '%%% %%% => e');
    dispatch(fetchUserActivityError(e));
  }
};

export const fetchSpaceList = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestSpaceList());
    const response = await fetchPublicProfileCircleDataApi({
      userId: params.id,
      fetchTab: 'posts',
      page: 1,
      per_page: 100,
    });
    const userGroups = Array.isArray(response?.spaces) ? response.spaces : [];
    dispatch(successSpaceList(userGroups));
    dispatch(fetchUserActivitySuccess(response?.activity || null));

    return userGroups;
  } catch (error) {
    dispatch(errorSpaceList(error));
  }
};

export const fetchUserBadges = (userId) => async (dispatch, getState) => {
  try {
    dispatch(fetchUserBadgesRequest());
    const data = await fetchUserBadgesApi({ userId });
    let badges = data.badges || [];

    // Check if user has subscription data - if yes, add Founding Member badge
    // const state = getState();
    // const subscriptionData = state.ProfilePage?.subscriptionData;

    // console.log('🔍 fetchUserBadges - subscriptionData:', subscriptionData);
    // console.log('🔍 fetchUserBadges - subId:', subscriptionData?.subId);
    // console.log('🔍 fetchUserBadges - current badges count:', badges.length);

    // if (subscriptionData?.subId) {
    //   // Check if Founding Member badge is not already in the list
    //   const hasFoundingMemberBadge = badges.some(badge => badge.badgeId === 'founding_member');

    //   console.log('✅ User has subscription! hasFoundingMemberBadge:', hasFoundingMemberBadge);

    //   if (!hasFoundingMemberBadge) {
    //     // Add Founding Member badge to the list
    //     const foundingMemberBadge = {
    //       badgeId: 'founding_member',
    //       name: 'Founding Member',
    //       description: 'Awarded when user purchased their membership in the first year of THQ being live',
    //       type: 'membershipTime',
    //       level: 'gold',
    //       categoryKey: 'membershipTime',
    //       categoryLabel: 'Membership Time',
    //       earnedAt: new Date(),
    //       isSpecial: true,
    //     };
    //     // badges = [...badges, foundingMemberBadge];
    //     badges = [...badges];
    //     console.log('🎉 Added Founding Member badge! Total badges:', badges.length);
    //   }
    // } else {
    //   console.log('❌ No subscription data found or no subId');
    // }

    dispatch(fetchUserBadgesSuccess(badges));
    return { badges };
  } catch (error) {
    console.error('Error fetching user badges:', error);
    dispatch(fetchUserBadgesError(error.message));
  }
};

export const showUser = (userId, config) => (dispatch, getState, sdk) => {
  dispatch(showUserRequest(userId));
  return sdk.users
    .show({
      id: userId,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const userFields = config?.user?.userFields;
      const sanitizeConfig = { userFields };
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(showUserSuccess());

      // Fetch private data (profile permissions and Stripe status)
      try {
        const { linkedAccountUserId } = response?.data?.data?.attributes?.profile?.publicData?.connectedAccount || {};
        if (linkedAccountUserId) {
          const linkId = new UUID(linkedAccountUserId);
          sdk.users
            .show({
              id: linkId,
              include: ['profileImage'],
              'fields.image': ['variants.square-small', 'variants.square-small2x'],
            })
            .then(res => {
              const userFields = config?.user?.userFields;
              const sanitizeConfig = { userFields };
              dispatch(addMarketplaceEntities(res, sanitizeConfig));
              return res;
            })
            .catch(() => { return null; });
        }
      } catch (error) {
      }
      return response;
    })
    .catch(e => dispatch(showUserError(storableError(e))));
};

const isCurrentUser = (userId, cu) => userId?.uuid === cu?.id?.uuid;


export const getMessageData = (userId) => (dispatch, getState, sdk) => {
  const currentUserId = getState()?.user?.currentUser?.id?.uuid;
  const otherUserId = userId?.uuid || userId;

  // Return the promise so callers can await/use the result
  return sdk.transactions
    .query({
      // Keeping existing filter; backend may ignore unknown filters.
      userId: userId,
      lastTransitions: ["transition/inquire-without-payment"],
      include: ['customer', 'provider'],
    })
    .then(res => {
      const txs = res?.data?.data || [];
      const findFirstTxInvolvingCurrentUser = txs.find(tx => {
        // Try relationships first, fall back to top-level included refs if available
        const customerId =
          tx?.relationships?.customer?.data?.id?.uuid || tx?.customer?.id?.uuid;
        const providerId =
          tx?.relationships?.provider?.data?.id?.uuid || tx?.provider?.id?.uuid;

        if (!currentUserId) return false;

        const involvesCurrent = customerId === currentUserId || providerId === currentUserId;

        // If a specific other user is provided, ensure this tx is between the two users
        const involvesOther = otherUserId
          ? customerId === otherUserId || providerId === otherUserId
          : true;

        return involvesCurrent && involvesOther;
      });

      // Build summary object or null
      let summary = null;
      if (findFirstTxInvolvingCurrentUser) {
        const tx = findFirstTxInvolvingCurrentUser;
        const customerId = tx?.relationships?.customer?.data?.id?.uuid || tx?.customer?.id?.uuid;
        const isCustomer = currentUserId && customerId === currentUserId;
        summary = {
          txId: tx?.id?.uuid || null,
          currentUser: isCustomer ? 'order' : 'sale',
        };
      }
      // Push to state
      dispatch(setMessageTxSummary(summary));
      return summary;
    })
    .catch(e => {
      // Surface errors in console; upstream handlers can also catch
      console.error('getMessageData error', e);
      throw e;
    });
}

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const userId = new UUID(params.id);
  const isPreviewForCurrentUser = params.variant === PROFILE_PAGE_PENDING_APPROVAL_VARIANT;
  const currentUser = getState()?.user?.currentUser;
  const email = currentUser?.attributes?.email;
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };
  // Clear state so that previously loaded data is not visible
  // in case this page load fails.
  dispatch(setInitialState());

  if (isPreviewForCurrentUser) {
    return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(() => {
      if (isCurrentUser(userId, currentUser) && isUserAuthorized(currentUser)) {
        // Scenario: 'active' user somehow tries to open a link for "variant" profile
        return Promise.all([
          dispatch(showUser(userId, config)),
          dispatch(queryUserListings(userId, config)),
          dispatch(queryUserReviews(userId)),
        ]);
      } else if (isCurrentUser(userId, currentUser)) {
        // Handle a scenario, where user (in pending-approval state)
        // tries to see their own profile page.
        // => just set userId to state
        return dispatch(showUserRequest(userId));
      } else {
        return Promise.resolve({});
      }
    });
  }

  // Fetch data for plain profile page.
  // Note 1: returns 404s if user is not 'active'.
  // Note 2: In private marketplace mode, this page won't fetch data if the user is unauthorized
  const isAuthorized = currentUser && isUserAuthorized(currentUser);
  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const hasNoViewingRights = currentUser && !hasPermissionToViewData(currentUser);
  const canFetchData = !isPrivateMarketplace || (isPrivateMarketplace && isAuthorized);
  // On a private marketplace, show active (approved) current user's own page
  // even if they don't have viewing rights
  const canFetchOwnProfileOnly =
    isPrivateMarketplace &&
    isAuthorized &&
    hasNoViewingRights &&
    isCurrentUser(userId, currentUser);

  if (!canFetchData) {
    return Promise.resolve();
  } else if (canFetchOwnProfileOnly) {
    return Promise.all([
      dispatch(fetchCurrentUser(fetchCurrentUserOptions)),
      dispatch(queryUserListings(userId, config, canFetchOwnProfileOnly)),
      dispatch(showUserRequest(userId)),
    ]);
  }

  // First, wait for getUserData to complete and set subscriptionData
  return dispatch(getUserData(params.id)).then(() => {
    // Then fetch everything else including badges
    return Promise.all([
      dispatch(fetchCurrentUser(fetchCurrentUserOptions)),
      dispatch(showUser(userId, config)),
      dispatch(queryUserListings(userId, config)),
      dispatch(queryUserReviews(userId)),
      dispatch(fetchSpaceList(params)),
      dispatch(searchGroups(params)),
      dispatch(getMessageData(userId)).catch(() => null),
      dispatch(fetchLandingPageListings({
        author_id: userId,
        page: 1,
        perPage: 4
      })),
      dispatch(fetchUserBadges(params.id)),
    ]);
  });
};
